import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';

import Loading from '../../Loading/LoadingView';
import AdvForm from '../../../CommonComponents/AdvForm';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import Footer from '../../Footer/FooterContainer';
import RadioWhatIf from '../../RadioWhatIf/RadioWhatIfView';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';
import AdvInput from '../../../CommonComponents/AdvInput';

class RefinanceView extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goal,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;

    const { GoalId } = goal;

    fetchData(clientId, fpId, GoalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, GoalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const {
      clientId, fpId, goal, whatIf, fetchPlanImpact, whatIfTemplate,
    } = this.props;
    const { GoalId } = goal;

    const impactTriggerProps = ['whatIf', 'fpId'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(previousProps, impactTriggerProps))) {
      fetchPlanImpact(clientId, fpId, GoalId, whatIf, whatIfTemplate);
    }
  }

  render() {
    const {
      loading,
      groupTitle,
      clientId,
      title,
      areOptionsLoaded,
      label,
      options,
      planImpactItems,
      fpId,
      goal,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      selectedRefinanceValue,
      saveStrategy,
      updateInterestRate,
      interestRate,
    } = this.props;

    const { GoalId } = goal;

    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>
              <li className="what-ifs-form-field">
                <span className="what-ifs-label-text">New Interest Rate:</span>
                <br />
                <AdvInputWrapper hasPercentage className="what-ifs-input-wrapper">
                  <AdvInput
                    type="text"
                    dataType="interest"
                    maxLength="14"
                    onBlur={value => (
                      updateInterestRate(clientId, GoalId, whatIfTemplate.WhatIfType, value)
                    )}
                    nullable
                    value={interestRate}
                    className="what-ifs-input"
                  />
                </AdvInputWrapper>
              </li>
              <li className="what-ifs-form-field">
                <span className="what-ifs-label-text">{label}</span>
                <br />
                {options.map(option => (
                  <RadioWhatIf
                    value={option.value}
                    label={option.label}
                    checked={selectedRefinanceValue === option.value}
                    onClick={() => {
                      saveStrategy(
                        clientId,
                        GoalId,
                        whatIfTemplate.WhatIfType,
                        option.value,
                      );
                    }}
                  />
                ))}
              </li>
            </ul>
          </AdvForm>
        </div>

        <PlanImpact
          clientId={clientId}
          planImpactItems={planImpactItems}
        />

        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, GoalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}

RefinanceView.defaultProps = {
  title: '',
  groupTitle: '',
};

RefinanceView.propTypes = {
  fpId: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  planImpactItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    current: PropTypes.string.isRequired,
    proposed: PropTypes.string.isRequired,
  })).isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  saveStrategy: PropTypes.string.isRequired,
  goal: PropTypes.shape({
    GoalId: PropTypes.string,
  }).isRequired,
  selectedRefinanceValue: PropTypes.string.isRequired,
  updateInterestRate: PropTypes.func.isRequired,
  interestRate: PropTypes.number.isRequired,
};

export default RefinanceView;
